export default __webpack_public_path__ + "static/media/GelBoxTop.36def1e6.svg";